import zeplinColor from 'theme/Color';

export const getCardStatus = (
  dealHealth: string,
  velocityTargetDate: number | null,
): { borderColor: string; dotColor: string; tooltipText: string } => {
  const health = String(dealHealth).toLowerCase();
  const velocity = typeof velocityTargetDate === 'number' ? Math.abs(velocityTargetDate) : 'N/A';
  const tooltipText = `Deal approaching velocity target in ${velocity} days`;

  switch (health) {
    case 'overdue':
      return {
        borderColor: zeplinColor.Error,
        dotColor: zeplinColor.Error,
        tooltipText: `Deal exceeded velocity target by ${velocity} days`,
      };
    case 'warning':
      return {
        borderColor: zeplinColor.AlertInfo,
        dotColor: zeplinColor.AlertInfo,
        tooltipText,
      };

    default:
      return {
        borderColor: zeplinColor.Neutral5,
        dotColor: zeplinColor.Success,
        tooltipText,
      };
  }
};
